import classNames from 'classnames';
import Select from 'react-select';
import { log } from './utility';

//  Import core block libraries
const { __ } = wp.i18n;
const { InspectorControls } = wp.blockEditor;
const {
	PanelBody,
	PanelRow,
	ServerSideRender,
	TextControl,
	RadioControl,
	SelectControl,
	Spinner,
} = wp.components;
const { registerBlockType } = wp.blocks;
const { Component, Fragment } = wp.element;

export class SelectFAQPosts extends Component {
	constructor( props ) {
		super( props );

		this.state = {
			loading: false,
			posts: [],
		};

		//console.log('constructor: <SelectFAQPosts />');
	}

	componentDidUpdate() {
		//console.log('componentDidUpdate: <SelectFAQPosts />');
	}

	componentDidMount() {
		//console.log('componentDidMount: <SelectFAQPosts />');

		this.setState( { loading: true } );

		const url = 'flexible-faqs/v1/posts';

		wp.apiFetch( { path: url, method: 'GET' } ).then(
			( data ) => {
				const posts = [];

				let newLabelObj = {};
				const entries = Object.entries( data );
				for ( const [ key, value ] of entries ) {
					// disable empty FAQ select options
					const itemStatus = value.includes( '(0)' );
					const tmp = {
						value: key,
						isDisabled: itemStatus,
						label: value,
					};

					// if the fetched ID is the same as the currently selected ID then update label
					if ( JSON.parse( this.props.faqPostId ).value == key ) {
						newLabelObj = tmp; //JSON.parse(this.props.faqPostId).label;
						//console.log('tmp: ', tmp);
						//console.log('VAL', JSON.parse(this.props.faqPostId).value);
					}
					//console.log(JSON.parse(this.props.faqPostId), key, value);

					posts.push( tmp );
				}

				this.setState(
					{
						posts,
						loading: false,
					},
					() => {
						const { setAttributes } = this.props;
						//console.log('newLabelObj', newLabelObj);

						// only update dropdown option label if there is one currently selected (i.e. this won't be the case for new block instances)
						if ( newLabelObj.hasOwnProperty( 'value' ) ) {
							setAttributes( {
								//faqItems: JSON.stringify(newFaqItems),
								id: newLabelObj.value,
								faqPostId: JSON.stringify( newLabelObj ),
							} );
						}
					}
				);

				return data;
			},
			( err ) => {
				return err;
			}
		);
	}

	updateFaqsPostSelect( newVal ) {
		const { setAttributes } = this.props;
		//    const url = `flexible-faqs/v1/get-faqs/${newVal.value}`;
		const id = newVal;

		//console.log('Update FAQ selection!', JSON.stringify(id.value));
		//		return;

		setAttributes( {
			//faqItems: JSON.stringify(newFaqItems),
			id: id.value,
			faqPostId: JSON.stringify( id ),
		} );
	}

	render() {
		const {
			setAttributes,
			faqPostId,
			multi = true,
			className,
		} = this.props;
		//console.log(JSON.stringify(this.props));

		// Not really needed as this displays a spinning icon EVERY time an FAQ block is clicked on which doesn't look great.
		// if ( this.state.loading ) {
		//   return (
		//     <p style={{'display': 'flex', 'align-items': 'center'}} className={className} >
		//       <Spinner />
		//       { __( 'Loading post types', 'flexible-faqs' ) }
		//     </p>
		//   );
		// }

		const selectStyles = {
			menuList: ( styles ) => {
				return {
					...styles,
					//backgroundColor: 'red',
					paddingBottom: 0,
					paddingTop: 0,
					maxHeight: 204,
				};
			},
			menu: ( styles ) => {
				//console.log('menu:', styles);
				return {
					...styles,
					zIndex: 100,
					borderRadius: 0,
					//backgroundColor: 'red',
				};
			},
			container: ( styles ) => ( {
				...styles,
				'& div[class$="-Input"]': {
					'& input:focus': {
						boxShadow: 'none',
					},
				},
			} ),
		};

		return (
			<Select
				value={ JSON.parse( faqPostId ) }
				//isMulti={multi}
				onChange={ ( val ) => this.updateFaqsPostSelect( val ) }
				options={ this.state.posts }
				className="react-select-container"
				classNamePrefix="react-select"
				placeholder="Select FAQs to display.."
				styles={ selectStyles }
			/>
		);
	}
}
